import axios from 'axios';

export default {
  async getApi(url, callback){
    const res = await axios.get(url);
    if(res.status === 200){
      callback(res.data);
    }else{
      alert('ネットワークの状態が不安定です。\n通信回線の良い状況で再度アクセスしてください');
    }
  },
}